/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import get from "lodash/get";
import React from "react";
import { decodeURIFromWidget } from "../../../../utils/decodeCustomCode";
import { AdService } from "../../../components/ad-service";
import { WidgetComponent } from "../../../components/Widget";
import WithArrowConfig from "../../hoc-components/with-arrow-config";

// this will be the wrapper inside ahead
const arrowWrapper = Component => ({ collection = {}, metadata = {}, index }) => {
  const config = get(metadata, ["config"], {});
  let { adType = "", targetingId = "", widget = "" } = config;

  const adComponent = () => {
    return (
      <div className="app-ad app-ad--story-horizontal">
        <AdService
          adtype={adType}
          adTargetingId={targetingId}
          layoutName="PageBuilder"
          slotId={`PB-${get(metadata, ["rowId"], "")}`}
        />
      </div>
    );
  };
  const widgetComp = () => {
    try {
      if (typeof window !== "undefined") {
        widget = window.atob(widget);
      } else {
        const bufferedWidget = Buffer.from(widget, "base64");
        widget = bufferedWidget.toString("utf-8");
      }
    } catch (e) {
      widget = "";
    }

    return (
      <div className="app-ad app-ad--story-horizontal">
        <WidgetComponent widgetValue={decodeURIFromWidget(widget)} />
      </div>
    );
  };

  const updateComp = ({ type }) => {
    switch (type) {
      case "ad":
        return adComponent;
      case "widget":
        return widgetComp;
      default:
        return null;
    }
  };

  const updateAdAndWidgetComponent = (config = {}) => {
    if (!config.slotConfig) return config;
    const { type } = get(config, ["slotConfig", 0], {});
    config.slotConfig[0].component = updateComp({ type });
    return config;
  };

  return (
    <div style={{ maxWidth: "1172px", margin: "auto" }}>
      {WithArrowConfig(Component)({ collection, config, index, updateAdAndWidgetComponent })}
    </div>
  );
};
export { arrowWrapper };
